export const isValidTypeValueGenerator = <T>(validTypeValues: T[]): (value: T) => boolean => {
  return (value: T) => validTypeValues.indexOf(value) > -1;
};
